// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-radio-group {
  display: flex;
  flex-direction: column;
  margin: 15px 0;
}

.example-radio-button {
  margin: 5px;
}

.checkbox-slides {
  margin-top: 15px;
}

#SinglePageView .example-radio-group {
  display: flex;
  flex-direction: row;
  margin: 0;
}

#SinglePageView .form-group {
  margin: 0;
}

.time_slot {
  padding-top: 25px;
  padding-bottom: 25px;
  width: 100%;
  background-color: #673ab7;
  color: white;
}

.mat-calendar {
  max-width: 425px;
}

.mat-expansion-panel-header {
  padding: 5px;
}

.mat-calendar-icon{
  vertical-align: middle;
  margin-top: -970px;
  margin-left: 420px;
}
mat-icon {
  position: relative;
  float: left;
  top: -3px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.54);
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZvbHVudGVlci1vcHBvcnR1bml0eS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBYTtFQUNiLHNCQUFzQjtFQUN0QixjQUFjO0FBQ2hCOztBQUVBO0VBQ0UsV0FBVztBQUNiOztBQUVBO0VBQ0UsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0UsYUFBYTtFQUNiLG1CQUFtQjtFQUNuQixTQUFTO0FBQ1g7O0FBRUE7RUFDRSxTQUFTO0FBQ1g7O0FBRUE7RUFDRSxpQkFBaUI7RUFDakIsb0JBQW9CO0VBQ3BCLFdBQVc7RUFDWCx5QkFBeUI7RUFDekIsWUFBWTtBQUNkOztBQUVBO0VBQ0UsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0UsWUFBWTtBQUNkOztBQUVBO0VBQ0Usc0JBQXNCO0VBQ3RCLGtCQUFrQjtFQUNsQixrQkFBa0I7QUFDcEI7QUFDQTtFQUNFLGtCQUFrQjtFQUNsQixXQUFXO0VBQ1gsU0FBUztFQUNULGVBQWU7RUFDZiwwQkFBMEI7QUFDNUIiLCJmaWxlIjoidm9sdW50ZWVyLW9wcG9ydHVuaXR5LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZXhhbXBsZS1yYWRpby1ncm91cCB7XHJcbiAgZGlzcGxheTogZmxleDtcclxuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xyXG4gIG1hcmdpbjogMTVweCAwO1xyXG59XHJcblxyXG4uZXhhbXBsZS1yYWRpby1idXR0b24ge1xyXG4gIG1hcmdpbjogNXB4O1xyXG59XHJcblxyXG4uY2hlY2tib3gtc2xpZGVzIHtcclxuICBtYXJnaW4tdG9wOiAxNXB4O1xyXG59XHJcblxyXG4jU2luZ2xlUGFnZVZpZXcgLmV4YW1wbGUtcmFkaW8tZ3JvdXAge1xyXG4gIGRpc3BsYXk6IGZsZXg7XHJcbiAgZmxleC1kaXJlY3Rpb246IHJvdztcclxuICBtYXJnaW46IDA7XHJcbn1cclxuXHJcbiNTaW5nbGVQYWdlVmlldyAuZm9ybS1ncm91cCB7XHJcbiAgbWFyZ2luOiAwO1xyXG59XHJcblxyXG4udGltZV9zbG90IHtcclxuICBwYWRkaW5nLXRvcDogMjVweDtcclxuICBwYWRkaW5nLWJvdHRvbTogMjVweDtcclxuICB3aWR0aDogMTAwJTtcclxuICBiYWNrZ3JvdW5kLWNvbG9yOiAjNjczYWI3O1xyXG4gIGNvbG9yOiB3aGl0ZTtcclxufVxyXG5cclxuLm1hdC1jYWxlbmRhciB7XHJcbiAgbWF4LXdpZHRoOiA0MjVweDtcclxufVxyXG5cclxuLm1hdC1leHBhbnNpb24tcGFuZWwtaGVhZGVyIHtcclxuICBwYWRkaW5nOiA1cHg7XHJcbn1cclxuXHJcbi5tYXQtY2FsZW5kYXItaWNvbntcclxuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xyXG4gIG1hcmdpbi10b3A6IC05NzBweDtcclxuICBtYXJnaW4tbGVmdDogNDIwcHg7XHJcbn1cclxubWF0LWljb24ge1xyXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcclxuICBmbG9hdDogbGVmdDtcclxuICB0b3A6IC0zcHg7XHJcbiAgY3Vyc29yOiBwb2ludGVyO1xyXG4gIGNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNTQpO1xyXG59XHJcbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/volunteer-opportunity/volunteer-opportunity.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA,45DAA45D","sourcesContent":[".example-radio-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 15px 0;\r\n}\r\n\r\n.example-radio-button {\r\n  margin: 5px;\r\n}\r\n\r\n.checkbox-slides {\r\n  margin-top: 15px;\r\n}\r\n\r\n#SinglePageView .example-radio-group {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin: 0;\r\n}\r\n\r\n#SinglePageView .form-group {\r\n  margin: 0;\r\n}\r\n\r\n.time_slot {\r\n  padding-top: 25px;\r\n  padding-bottom: 25px;\r\n  width: 100%;\r\n  background-color: #673ab7;\r\n  color: white;\r\n}\r\n\r\n.mat-calendar {\r\n  max-width: 425px;\r\n}\r\n\r\n.mat-expansion-panel-header {\r\n  padding: 5px;\r\n}\r\n\r\n.mat-calendar-icon{\r\n  vertical-align: middle;\r\n  margin-top: -970px;\r\n  margin-left: 420px;\r\n}\r\nmat-icon {\r\n  position: relative;\r\n  float: left;\r\n  top: -3px;\r\n  cursor: pointer;\r\n  color: rgba(0, 0, 0, 0.54);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
